class CompareButton extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('click', this.compareProduct.bind(this));
  }

  compareProduct(event) {
    const prodDataElement = this.querySelector('#prodData');
    let productData = {};
    if (prodDataElement && prodDataElement.textContent.trim().startsWith('{')) {
      productData = JSON.parse(prodDataElement.textContent.trim());
    }
    const compareData = JSON.parse(localStorage.getItem('kenro-comparedProducts')) || [];
    const productIndex = compareData.findIndex((product) => product.id === productData.id);

    if (productIndex > -1) {
      compareData.splice(productIndex, 1);
    }

    if (compareData.length >= 4) {
      compareData.shift(); // Remove the oldest product to maintain the limit
    }

    compareData.push(productData);
    localStorage.setItem('kenro-comparedProducts', JSON.stringify(compareData));
    window.location.href = '/pages/compare-products';
  }
}

customElements.define('compare-button', CompareButton);

export default CompareButton;
